import React, { useState, useCallback, useEffect, useMemo } from "react";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { exprienceAPI } from "../../api/skillm";
import * as XLSX from "xlsx";

const ExperienceMatrix = () => {
  const columns = useMemo(
    () => [
      {
        name: "Skills",
        selector: (row) => row.skill_title,
        wrap: true,
      },
      {
        name: "0-5",
        selector: (row) => row.ztof_year,
      },
      {
        name: "6-8",
        selector: (row) => row.ftoe_year,
      },
      {
        name: "9-12",
        selector: (row) => row.etot_year,
      },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      let query = new URLSearchParams(params).toString();
      setLoading(true);
      exprienceAPI(query)
        .then((res) => {
          setData(res?.data);
          setTotalRows(res?.total);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const downloadExcel = () => {
    // Prepare data for Excel export
    const worksheetData = data.map((d) => ({
      "Skill Title": d.skill_title,
      "0-5 Years": d.ztof_year,
      "6-8 Years": d.ftoe_year,
      "9-12 Years": d.etot_year,
    }));

    // Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Experience Matrix");

    // Save the file
    XLSX.writeFile(workbook, "ExperienceMatrix.xlsx");
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <button className="btn btn-primary" onClick={downloadExcel}>
          Download Excel
        </button>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              persistTableHead
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
            {/* <table className="table display mb-4 dataTablesCard Plan-table table-responsive-xl card-table dataTable no-footer">
              <thead>
                <tr>
                  <th>Skills</th>
                  <th>0-5</th>
                  <th>6-8</th>
                  <th>9-12</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((d, index) => (
                  <tr key={index}>
                    <td>{d.skill_title}</td>
                    <td>{d.ztof_year}</td>
                    <td>{d.ftoe_year}</td>
                    <td>{d.etot_year}</td>
                  </tr>
                ))}
              </tbody>
            </table> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExperienceMatrix;
